// Корневой контейнер приложения. Пропсы platform/appearance принимаются
// для совместимости и никуда не идут: тема приложения захардкожена на dark
// (класс "dark" приходит в className, на него завязан index.css).
export function AppRoot({ children, className = "", id }) {
  return (
    <div id={id} className={`ui-root ${className}`}>
      {children}
    </div>
  );
}
